import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { TopSection } from "./About";
import Wave from "../components/Wave2";
import axios from "axios";

const Card = ({ service, isMobile, onClick }) => {
  const cardStyles = {
    width: isMobile ? "45vw" : "40vw",
    aspectRatio: "3 / 4",
    border: "2px dashed #f87171",
    borderRadius: "40px",
    padding: isMobile ? "6px" : "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    boxSizing: "border-box",
    backgroundColor: "#fff",
    cursor: "pointer",
  };

  const headerStyles = {
    margin: "12px 0 8px 0",
    fontSize: isMobile ? "12px" : "20px",
  };

  const paragraphStyles = {
    fontSize: isMobile ? "12px" : "22px",
    color: "#555",
    fontFamily: "Outfit",
  };

  const buttonStyles = {
    margin: "20px auto",
    fontSize: isMobile ? "12px" : "16px",
    width: isMobile ? "90%" : "auto",
    padding: isMobile ? "8px 16px" : "10px 20px",
    border: "none",
    cursor: "pointer",
  };

  return (
    <div style={cardStyles} onClick={onClick}>
      <div
        style={{
          height: "50%",
          border: "1px dashed #00000040",
          borderRadius: "30px",
          background: `url(${service.images?.[0]?.src}) no-repeat center center`,
          backgroundSize: "cover",
        }}
      />
      <div>
        <h2 style={headerStyles}>{service.title}</h2>
        <p style={paragraphStyles}>{service.shortDescription || service.description}</p>
      </div>
      <button className="btn" style={buttonStyles}>
        View Details
      </button>
    </div>
  );
};

const CategoryDetail = () => {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [services, setServices] = useState([]);
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setLoading(true);
    
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/service-categories/${categoryId}`)
      .then((res) => setCategory(res.data))
      .catch(() => setCategory(null));

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/services/category/${categoryId}`)
      .then((res) => setServices(res.data || []))
      .catch(() => setServices([]))
      .finally(() => setLoading(false));
  }, [categoryId]);

  const handleServiceClick = (serviceId) => {
    navigate(`/service/${serviceId}`);
  };

  return (
    <>
      <TopSection heading={category?.name || "Services"}>
        <h2 style={{ fontSize: isMobile ? "20px" : "40px", color: '#DF2126' }}>
          {category?.description || ""}
        </h2>
      </TopSection>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "10px",
          maxWidth: "1000px",
          margin: "0 auto",
        }}
      >
        {loading ? (
          <div>Loading...</div>
        ) : services.length === 0 ? (
          <div>No services found in this category.</div>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: isMobile ? "8px" : "16px",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            {services.map((service) => (
              <Card
                key={service._id}
                service={service}
                isMobile={isMobile}
                onClick={() => handleServiceClick(service._id)}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default CategoryDetail;
